import merge from 'lodash/merge'
import txGroupTheme from 'theme/shared/themes/txgroup'
import {BRANDS} from 'const'
import {getFavicon, getFooterLogosByBrandList, getHeaderLogo} from '../commonHelper'
import {isProd} from 'utils/envUtils'

const brand = BRANDS.twentyfourhours
const brandUrl = 'https://www.24heures.ch'
const otherBrandsLogos = getFooterLogosByBrandList([
  BRANDS.twentyfourhours,
  BRANDS.tribunedegeneve,
  BRANDS.lematindimanche,
  BRANDS.bilan,
])
const authorizeRedirectURL = isProd()
  ? 'https://abo-digital.24heures.ch/identity-service/auth/authorize?redirect_uri=https://24heures.ch&source_client=web&response_type=token'
  : 'https://abo-digital-dev.24heures.ch/identity-service/auth/authorize?redirect_uri=https://master.dev.24heures.ch&source_client=web&response_type=token'

export default merge({}, txGroupTheme, {
  brand: {
    name: brand,
    url: brandUrl,
    favicon: getFavicon(brand),
    authorizeRedirectURL,
  },
  shell: {
    header: {
      logo: {
        height: {
          default: '40px',
          small: '28px',
          onScroll: '28px',
        },
        src: {
          default: getHeaderLogo(brand),
        },
      },
    },
  },
  otherBrandsLogos,
})
